@if (initialLoadUser$ | async) {
  @if (onLoading()) {
    <div class="flex h-screen flex-column">
      <div class="flex h-full w-full justify-content-center align-items-center bg-landing">
        <div
          class="flex flex-column gap-4 justify-content-center align-items-center border-round-2xl bg-white"
          style="width: 420px; height: 310px"
        >
          <p-image src="assets/images/img-profile-login.png" alt="check-email" width="80px" />
          <p class="text-lg text-color font-semibold text-center">Login Success</p>
          <div class="w-full px-6">
            <p-button label="Next" styleClass="w-full" (click)="handleRedirect()" />
          </div>
        </div>
      </div>
    </div>
  } @else {
    Redirecting...
  }
} @else {
  <div>Checking...</div>
}

<!-- check
<p-button label="Debug" styleClass="w-full" (click)="debug()" />
<p-button label="Next" styleClass="w-full" (click)="handleRedirect()" /> -->
